import { IconDictionaryItem } from "@cmp-src/controls";

export const TacticIconsDictionary: Record<string, IconDictionaryItem> = {
  tactic: {
    icons: {
      AccessibilityRestroom: "Accessibility Restroom",
      AccessRestroom: "Access Restroom",
      AED: "AED",
      BikeRoom: "Bike Room",
      Booth: "Booth",
      Coffee: "Coffee",
      Data: "Data",
      DataRoom: "Data Room",
      Electrical: "Electrical",
      Elevator: "Elevator",
      Exit: "Exit",
      FemaleRestroom: "Female Restroom",
      FireExtinguisher: "Fire Extinguisher",
      FirstAid: "First Aid",
      FoodAndBev: "Food & Beverage",
      GenderNeutral: "Gender Neutral",
      Gym: "Gym",
      JanitoralCloset: "Janitorial Closet",
      Kitchen: "Kitchen",
      KitchenPlate: "Kitchen Plate",
      Library: "Library",
      LibraryRoom: "Library Room",
      Lobby: "Lobby",
      Lockers: "Lockers",
      Mail: "Mail",
      MaleRestroom: "Male Restroom",
      Mechanical: "Mechanical",
      MechanicalRoom: "Mechanical Room",
      MicrophoneRoom: "Microphone Room",
      MothersRoom: "Mother's Room",
      NoSound: "No Sound",
      Phone: "Phone",
      PhoneRoom: "Phone Room",
      Printer: "Printer",
      QuietRoom: "Quiet Room",
      ScienceLab: "Science Lab",
      ServerRoom: "Server Room",
      Shower: "Shower",
      SoundBooth: "Sound Booth",
      Stairs: "Stairs",
      Storage: "Storage",
      ToiletRestroom: "Toilet Restroom",
      TrashRoom: "Trash Room",
      WellnessRoom: "Wellness Room"
    },
    keys: [
      "AccessibilityRestroom",
      "AccessRestroom",
      "AED",
      "BikeRoom",
      "Booth",
      "Coffee",
      "Data",
      "DataRoom",
      "Electrical",
      "Elevator",
      "Exit",
      "FemaleRestroom",
      "FireExtinguisher",
      "FirstAid",
      "FoodAndBev",
      "GenderNeutral",
      "Gym",
      "JanitoralCloset",
      "Kitchen",
      "KitchenPlate",
      "Library",
      "LibraryRoom",
      "Lobby",
      "Lockers",
      "Mail",
      "MaleRestroom",
      "Mechanical",
      "MechanicalRoom",
      "MicrophoneRoom",
      "MothersRoom",
      "NoSound",
      "Phone",
      "PhoneRoom",
      "Printer",
      "QuietRoom",
      "ScienceLab",
      "ServerRoom",
      "Shower",
      "SoundBooth",
      "Stairs",
      "Storage",
      "ToiletRestroom",
      "TrashRoom",
      "WellnessRoom"
    ]
  }
};
